import { render, staticRenderFns } from "./DespesasCategoriaCard.vue?vue&type=template&id=2f3e2c40"
import script from "./DespesasCategoriaCard.vue?vue&type=script&lang=js"
export * from "./DespesasCategoriaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports